const StatusCompra = Object.freeze({
  TODAS: 'Todas',
  DISPONIVEIS: 'Disponíveis',
  DESCARTADAS: 'Descartadas',
  NAO_CLASSIFICADAS: 'Não Classificadas'
});

export default StatusCompra;
